import { Grid, Skeleton } from '@mantine/core';
import XTextStackInfo from '../x-text-stack-info.component';

function XSkeleton1Fields(props: Props) {
  const { skeletonHeight, skeletonWidth, skeletonXS } = props;
  const height = skeletonHeight ?? 14;
  const width = skeletonWidth ?? '100%';
  const xs = skeletonXS ?? 3;
  const fillXS = 12 - xs;
  return (
    <>
      <Grid.Col xs={xs}>
        <XTextStackInfo
          label={<Skeleton height={height} width={'50%'} />}
          value={<Skeleton height={height} width={width} />}
        />
      </Grid.Col>
      <Grid.Col xs={fillXS}></Grid.Col>
    </>
  );
}

interface Props {
  skeletonHeight?: number;
  skeletonWidth?: number | string;
  skeletonXS?: number;
}

export default XSkeleton1Fields;
